import { render, staticRenderFns } from "./comp-room.vue?vue&type=template&id=788ecd52&scoped=true"
import script from "./comp-room.vue?vue&type=script&lang=js"
export * from "./comp-room.vue?vue&type=script&lang=js"
import style0 from "./comp-room.vue?vue&type=style&index=0&id=788ecd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_3rkfgw2sufrnjnd565hqczepoe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ecd52",
  null
  
)

/* custom blocks */
import block0 from "./comp-room.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports